import { useTranslation } from 'react-i18next';
export function useCredentialingTranslation() {
    return useTranslation('credentialing');
}
